export const formatDeliveryDate = (date: Date) =>
  date.toLocaleDateString('us-EN', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
